(function ($) {
  function initGraphScroll() {
    const $graph = $('.box-graph');
    const $graphScroll = $('#scroll');
    const $graphSVG = $graphScroll.find('svg:visible');
    const graphHeight = $graph.outerHeight();
    let ticking = false;

    if (!$graph.length || !$graphSVG.length) return;

    $graph.find('path, .dot-marker').hover(function () {
      const item = $(this).data('target');
      $graph.addClass('over-' + item);
    }, function () {
      const item = $(this).data('target');
      $graph.removeClass('over-' + item);
    });

    function handleScroll() {
      const scrollTop = $(window).scrollTop();
      const g_start = $graph.position().top;
      const g_finish = g_start + graphHeight - $(window).height();

      if (scrollTop > g_start && scrollTop < g_finish) {
        const scroll_start = scrollTop - g_start - 86;
        let scroll_percent = (scroll_start / (graphHeight - $(window).height())) * 100;
        scroll_percent = Math.max(0, Math.min(scroll_percent, 100));

        const setNewScroll = ($graphSVG[0].scrollWidth - $graphScroll[0].clientWidth) * (scroll_percent / 100);
        $graphScroll.stop().animate({ scrollLeft: setNewScroll }, 200, 'linear');

        $graph.removeClass([
          'over-green-1', 'over-yellow-1', 'over-red-1', 'over-blue-1',
          'over-green-2', 'over-yellow-2', 'over-red-2', 'over-blue-2'
        ].join(' '));

        for (let i = 7; i >= 0; i--) {
          if (scroll_percent > (i * 10)) {
            $graph.addClass('s' + i);
            switch (i) {
              case 0: $graph.addClass('over-green-1'); break;
              case 1: $graph.addClass('over-yellow-1'); break;
              case 2: $graph.addClass('over-red-1'); break;
              case 3: $graph.addClass('over-blue-1'); break;
              case 4: $graph.addClass('over-red-2'); break;
              case 5: $graph.addClass('over-yellow-2'); break;
              case 6: $graph.addClass('over-green-2'); break;
              case 7: $graph.addClass('over-blue-2'); break;
            }
          } else {
            $graph.removeClass('s' + i);
          }
        }
      }

      ticking = false;
    }

    $(window).on('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    });
  }

  $(document).ready(initGraphScroll);
})(jQuery);
